<template>
<div id="app">
    <v-app>

        <v-fade-transition mode="out-in">
            <component :is="getDynamicComponent()" />
        </v-fade-transition>

        <!-- snackbar -->
        <v-snackbar v-model="snackbar" :color="alert.type" :timeout="timeout" bottom left>{{alert.message}}</v-snackbar>
        <!-- ./ snackbar -->

    </v-app>
</div>
</template>

<script>
import AppContainer from './views/app/AppContainer.vue';
import AuthContainer from '@imemento/spa-helpers/src/views/auth/AuthContainer.vue';
import Healthy from '@imemento/spa-helpers/src/views/healthy/Healthy.vue';

import {
    mapActions,
    mapGetters
} from 'vuex';

import storage from './storage';

export default {
    components: {
        'im-healthy-container': Healthy,
        'im-app-container': AppContainer,
        'im-auth-container': AuthContainer,
    },

    // this will make sure view app is refreshed
    // if the user logged-in/logged-out on another spa
    mounted() {
        window.onfocus = async () => {
            let token = await storage.getToken();
            let roles = await storage.getRoles();

            if((!token && !roles) && this.$route.meta.private_route) {
                this.$router.push('/authentication/login')
            }

            if(token && roles && !this.$route.meta.private_route) {
                this.$router.push('/')
            }
        };

    },
    created() {
        this.getLocales('juvo-console');
    },

    data() {
        return {
            snackbar: false,
            timeout: 2500
        }
    },

    watch: {
        snackbar: {
            handler: function (snackbar) {
                if(snackbar === false) {
                    this.clear()
                }
            },
            deep: true
        },
        alert: {
            handler: function (alert) {
                this.snackbar = (alert.visible === true)
            },
            deep: true
        }
    },

    computed: {
        ...mapGetters('alert', ['alert'])
    },

    methods: {
        ...mapActions('alert', ['clear']),

        getLocales(app_slug) {
            let vm = this;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/identifiers/all';
            this.$axios.get(endpoint + `/${app_slug}.json`)
                .then(response => {
                    this.$vuetify.lang.locales.en = { ...this.$vuetify.lang.locales.en,
                        ...response.data.en
                    };
                    this.$vuetify.lang.locales.ro = { ...this.$vuetify.lang.locales.ro,
                        ...response.data.ro
                    };
                    this.$i18n.mergeLocaleMessage('en', response.data.en);
                    this.$i18n.mergeLocaleMessage('ro', response.data.ro);
                    this.$i18n.locale = 'ro';
                    this.$vuetify.lang.current = 'ro';
                })
                .catch(error => {
                    vm.$store.commit("SET_NETWORK_ERROR", error);
                });
        },

        getDynamicComponent() {
            if(this.$route.path === '/healthy')
                return 'im-healthy-container';

            if(this.$route.meta.private_route === false)
                return 'im-auth-container';

            if(this.$route.meta.private_route === true)
                return 'im-app-container';

            if(this.$route.meta.private_route === undefined)
                return '';
        }

    }
}
</script>
